// extracted by mini-css-extract-plugin
export default {"wrapper":"Jfa","container":"Kfa","title":"Lfa","desc":"Mfa","usage":"Nfa","box":"Ofa","subtitle":"Pfa","ingredients":"Qfa","carousel":"Rfa","ingredientscarousel":"Sfa","productinfo":"Tfa","ingredientsinfo":"Ufa"};
    if(module.hot) {
      // 1730991513152
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  